module.exports = __webpack_public_path__ + "img/google-plus-circled.f9519086.png";